module.exports = __webpack_public_path__ + "img/decorationBackgroundImg.9c34f5f5.png";